export const persistenceMode =
  import.meta.env.VITE_PERSISTENCE_MODE?.trim().toLowerCase() ?? "local";

export const cloudPersistenceEnabled = persistenceMode === "supabase";

export const starfallAuthUrl =
  import.meta.env.VITE_STARFALL_AUTH_URL?.trim() || "https://starfallworks.com";

export const appEnvironment =
  import.meta.env.VITE_APP_ENV?.trim() || (cloudPersistenceEnabled ? "development" : "local");


export const worldwardenEntitlementSlug =
  appEnvironment === "development" || appEnvironment === "beta"
    ? "worldwarden-beta"
    : "worldwarden";
